// extracted by mini-css-extract-plugin
export default {"list":"navList_list__s0wwv","item":"navList_item__tsguM","link":"navList_link__eI69h"};